import { SearchForm } from "@/component-create/SearchForm";
import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";

export function RenderSearch(el: Element) {
  const search = new SearchForm(el, items)
  return search
}

const items = [
  createFormItem('字典名称', 'dictionaryName', FORM_ITEM.INPUT),
  createFormItem('字典编码', 'dictionaryCode', FORM_ITEM.INPUT),
  createFormItem('状态', 'status', FORM_ITEM.SELECT, {  loader: 'DICTIONARY_STATUS', default: true, allOption: true })
]